import get from 'lodash/get'
import { FC, ReactElement, useState } from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { AssetContextType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { IconChevronLeft, IconChevronRight } from '@avantstay/backoffice-vectors'

import * as S from './PhotoCarousel.styles'

interface Asset {
  id: string
  context: AssetContextType
  s3Bucket: string
  s3Key: string
  public: boolean
  url: string
  fileName?: string
}

interface PhotoCarouselProps {
  assets: Asset[]
  initialAssetIndex?: number
  showThumbs?: boolean
  disabled?: boolean
}

export const PhotoCarousel: FC<PhotoCarouselProps> = ({
  assets,
  initialAssetIndex,
  showThumbs,
  disabled,
}) => {
  const [selectedPhoto, setSelectedPhoto] = useState<number>(initialAssetIndex ?? 0)
  return (
    <S.CarouselContainer $isDisabled={disabled}>
      <Carousel
        showArrows={assets.length > 1}
        selectedItem={selectedPhoto}
        showStatus={false}
        renderArrowPrev={(handleClick, isEnable) => (
          <S.CarouselArrowButton
            type="button"
            $isPrevious
            onClick={handleClick}
            disabled={!isEnable}
          >
            <IconChevronLeft />
          </S.CarouselArrowButton>
        )}
        renderArrowNext={(handleClick, isEnable) => (
          <S.CarouselArrowButton type="button" onClick={handleClick} disabled={!isEnable}>
            <IconChevronRight />
          </S.CarouselArrowButton>
        )}
        showThumbs={showThumbs}
        renderThumbs={children =>
          children.map(item => {
            const { key } = item as ReactElement

            return (
              <S.ThumbContainer key={`thumb-${key}`}>
                <S.ThumbImage src={get(item, 'props.children.props.src') || ''} />
              </S.ThumbContainer>
            )
          })
        }
      >
        {assets?.map((image, imageIndex) => {
          const imageId = image.id

          return (
            <S.ImageWrapper key={`image-${imageId}`} onClick={() => setSelectedPhoto(imageIndex)}>
              <S.ImagePreview
                src={`https://imglite.avantstay.com/${image.url}?avif=false&webp=true&quality=0.8`}
                quality={80}
              />
            </S.ImageWrapper>
          )
        })}
      </Carousel>
    </S.CarouselContainer>
  )
}
